import React, { useEffect, useState } from "react";
import { Droppable, DroppableProps } from "react-beautiful-dnd";

/**
 * React 18 StrictMode compatibility wrapper for react-beautiful-dnd Droppable.
 * It delays droppable mounting to the next animation frame to avoid
 * double-mount timing issues in development strict mode.
 */
const StrictModeDroppable: React.FC<DroppableProps> = (props) => {
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const animationFrame = requestAnimationFrame(() => {
            setEnabled(true);
        });

        return () => {
            cancelAnimationFrame(animationFrame);
            setEnabled(false);
        };
    }, []);

    if (!enabled) {
        return null;
    }

    return <Droppable {...props} />;
};

export default StrictModeDroppable;
